// extracted by mini-css-extract-plugin
module.exports = {"content":"_1JwymaTUXv7BfRTI8F8PHP"};